import { Component, OnInit } from "@angular/core";
import { FormControl, UntypedFormBuilder } from "@angular/forms";
import {
  StringCustomFieldConfig,
  DataService,
  SharedModule,
  FormInputComponent,
  ModalService,
} from "@bb-vendure/admin-ui/core";
import {
  switchMap,
  catchError,
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { Observable, of, Subject, concat, tap, take } from "rxjs";
import {
  FetchWarehouseDocument,
  FetchWarehouseQuery,
  SortOrder
} from "../generated-graphql/graphql";

export type AddArtistResult = {
  artistId: string | undefined;
};

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: "warehouse-dropdown",
  templateUrl: "./warehouse-dropdown.component.html",
})
export class WarehouseDropdownComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit
{
  resolveWith: (result?: AddArtistResult) => void;
  constructor(
    private dataService: DataService,
    private modalService: ModalService
  ) {}

  isListInput?: boolean = false;
  readonly: boolean;
  formControl: FormControl<any>;
  config: StringCustomFieldConfig;
  items$: Observable<FetchWarehouseQuery["warehouses"]["items"]>;
  input$ = new Subject<string>();
  isLoading = false;
  selectedArtist: any;
  ngOnInit(): void {
    this.dataService
      .query(FetchWarehouseDocument, {
        options: {
          sort: {
            createdAt: SortOrder.Asc
          },
          take: 1
        },
      })
      .single$.subscribe(({ warehouses }) => {
        if (warehouses.items && !this.formControl.value) {
          this.formControl.patchValue(warehouses.items[0]);
        }
      });

    this.items$ = concat(
      this.dataService
        .query(FetchWarehouseDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .single$.pipe(
          switchMap((data) => {
            return of(data.warehouses.items);
          })
        ),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((term) =>
          this.dataService
            .query(FetchWarehouseDocument, {
              options: {
                filter:
                  term && term.length > 0
                    ? {
                        warehouseCode: {
                          contains: term,
                        },
                      }
                    : undefined,
                take: 10,
                sort: {
                  createdAt: SortOrder.Desc,
                },
              },
            })
            .mapStream(({ warehouses }) => warehouses.items)
            .pipe(
              catchError(() => of([])), 
              tap(() => (this.isLoading = false))
            )
        )
      )
    );
  }
  compareFn(item1: { id: string } | null, item2: { id: string } | null) {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  trackByFn(item: { id: any }) {
    return item.id;
  }
}
